import { z } from 'zod';

export const getCategoriesSchema = z.object({
  module_id: z.uuid('Invalid module ID').optional(),
  parent_id: z.uuid('Invalid parent ID').optional(),
  search: z.string().optional(),
  is_active: z
    .string()
    .optional()
    .transform((val) => (val === 'true' ? true : val === 'false' ? false : undefined))
    .pipe(z.boolean().optional()),
  include_tree: z
    .string()
    .optional()
    .transform((val) => val === 'true')
    .pipe(z.boolean()),
  limit: z
    .string()
    .optional()
    .default('50')
    .transform((val) => Number.parseInt(val, 10))
    .pipe(z.number().min(1).max(100)),
  page: z
    .string()
    .optional()
    .default('0')
    .transform((val) => Number.parseInt(val, 10))
    .pipe(z.number().min(0)),
});

export const getCategorySchema = z.object({
  category_id: z.uuid('Invalid category ID'),
});

export const deleteCategorySchema = z.object({
  category_id: z.uuid('Invalid category ID'),
});

export const getCategoryTreeSchema = z.object({
  module_id: z.uuid('Invalid module ID'),
});

export type GetCategoriesPayload = z.infer<typeof getCategoriesSchema>;
export type GetCategoryPayload = z.infer<typeof getCategorySchema>;
export type DeleteCategoryPayload = z.infer<typeof deleteCategorySchema>;
export type GetCategoryTreePayload = z.infer<typeof getCategoryTreeSchema>;
